import type { Group } from '@microsoft/microsoft-graph-types'

import { ISnippetSourceDetails } from '@/types/gigiChat/ConversationSettings'

import { acquireTokenSilent, pca } from './MSAL'
import { getSnippetSourcesId } from './systemGroups'

export const checkUserMembership = async (snippetSources: ISnippetSourceDetails): Promise<{ value: Pick<Group, 'id'>[] } | void> => {
    const groups = getSnippetSourcesId(snippetSources)
    const msalSilentToken = await acquireTokenSilent(pca, ['User.Read'])

    let groupsString = ''
    groups.map((group, index) => {
        groupsString += `'${group}'${index < groups.length - 1 ? ',' : ''}`
    })

    if (!groupsString) {
        return
    }

    return fetch(
        `https://graph.microsoft.com/v1.0/me/memberOf?$count=true&$select=id&$filter=id in (${groupsString})`,

        {
            headers: {
                Authorization: `Bearer ${msalSilentToken.accessToken}`,
                ConsistencyLevel: 'eventual',
            },
        },
    )
        .then((res) => {
            if (res.ok) {
                return res.json()
            }
        })
        .catch((reason) => {
            // if it fails we ignore the error and log, basically becomes the same as the "if (!groupsString)" code path
            console.error(reason)
        })
}
